import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Button, Col, Modal } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import 'react-toastify/dist/ReactToastify.css';
import { PostApi } from '../../../services/CommonService2';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import badge from '../../../img/badge.png'
import certificateBg from '../../../img/certificate2.png';
import certified from '../../../img/certified.png';
import logo from '../../../img/logo.jpg';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ReactDOM from 'react-dom';
import { toPng } from 'html-to-image';
const MyProgramsItemList = (props) => {

    const [showCertificate, setShowCertificate] = useState(false);
    const certificateRef = useRef(null);

    const certificateContainerRef = useRef(null);

    useEffect(() => {
        setCurrentPage(1)
    }, [props.searchData])

    const history = useHistory();
    const [msg, setMsg] = useState(false)
    const [modal, setModal] = useState(false)
    const [newData, setNewData] = useState([])
    const [userId, setUserId] = useState("")
    const [programid, setProgramid] = useState("")
    // const [mainSectionId, setMainSectionId] = useState(null)
    const [QuizTitle, setQuizTitle] = useState(null)
    const [show, setShow] = useState(false);
    const [tanantid, setTanantId] = useState("")
    const [confirm, setConfirm] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;
    const lastIndex = currentPage * recordsPerPage;
    const firstIndex = lastIndex - recordsPerPage;
    const npage = Math.ceil(props.courseList.length / recordsPerPage)
    const records = props.courseList.slice(firstIndex, lastIndex)
    const numbers = [...Array(npage + 1).keys()].slice(1)
    const [loading, setLoading] = useState(false)
    const [user, setUser] = useState()
    const [todaysdate, setTodaysDate] = useState()


    useEffect(() => {
        var tntId = JSON.parse(localStorage.getItem('tID'))
        const sessiondetails = localStorage.getItem(`userdata${tntId}`);
        const userdata = JSON.parse(sessiondetails);
        setUser(userdata)
        const today = new Date();
        const formatted =
            today.getDate().toString().padStart(2, '0') + '/' +
            (today.getMonth() + 1).toString().padStart(2, '0') + '/' +
            today.getFullYear();
        setTodaysDate(formatted)

    }, [])

    const prePage = () => {
        window.scroll(0, 0)
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }


    }
    const nextPage = () => {
        window.scroll(0, 0)
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }

    }
    const changeCPage = (id) => {
        window.scroll(0, 0)
        setCurrentPage(id)

    }
    const detailsFun = (data) => {
        console.log("data", data);
        setNewData(data)
        // if (data.coursestatus == "completed") {
        //     setModal(true)

        // }
        // else {
        history.push({
            pathname: '/course-grid',
            state: data

        })

        // }

    }
    const assesmentModal = async () => {
        cancelmodal()
        setShow(true)

        setUserId(newData.userid)
        setProgramid(newData.programid)

        const data = records.filter(element => {
            return element.programid == newData.programid
        })

        setQuizTitle(data[0].name)

        const reqparam = {
            pageno: '-1',
            query: {}
        }

        const tenantresp = await PostApi(reqparam, 'TENANT');
        setTanantId(tenantresp.data[0].tenantid)
        // setMainSectionId(newData.id)

    }
    const viewCourse = async () => {
        // console.log("newData",newData);
        history.push({
            pathname: '/course-grid',
            state: newData

        })


    }
    const cancelmodal = async () => {
        setModal(false)
    }
    useEffect(() => {
        if (records?.length == 0) {
            setMsg(true)
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
            }, 5000);

        }
        else {
            setMsg(false)
            setLoading(false)
        }
    }, [props])
    const goBack = () => {
        history.push("/");
    };

    const handleConfirm = () => {
        setConfirm(false)
        setShow(false)
    }
    const handleMainClose = () => {
        setConfirm(true)
    }

    const gencertificate = async () => {
        if (certificateRef.current === null) return;

        try {
            const dataUrl = await toPng(certificateRef.current, { quality: 1, cacheBust: true });

            const pdf = new jsPDF('landscape', 'pt', 'a4');
            const imgProps = pdf.getImageProperties(dataUrl);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            pdf.addImage(dataUrl, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save('certificate.pdf');
        } catch (error) {
            console.error('Failed to generate PDF:', error);
        }
    };

    const certificateModal=async(data)=>{
        setNewData(data)
        setShowCertificate(true)
        
    }






    return (
        <>
            <button className="btn btn-primary" onClick={goBack} style={{ position: "fixed", bottom: "20px", left: "10px", zIndex: 999, width: "30px" }}><i className="fa-solid fa-arrow-left"></i></button>
            <Fragment>
                {records.length > 0 ? records?.map((data, i) => {
                    let imageid = 'https://visualpathedu.com/static/media/4th-year.15b862d606512e3257c0.jpg';
                    if (data?.image) {
                        imageid = data.image;
                    } else if (data?.image_url) {
                        imageid = data.image_url;
                    }
                    else {
                        imageid = data.imageurl ? data.imageurl : "";
                    }
                    return <Col md="12" key={i} >
                        <div className="course-item d-flex" >
                            <div className="course-image-box">
                                <div className="course-image">
                                    <div className="author-img ">
                                        <div className="img">
                                        </div>
                                    </div>
                                    <img src={imageid} className="course-image" ></img>

                                </div>
                            </div>
                            <div className="course-content" style={{ width: "100%" }}  >
                                <h6 className="heading">{data.name}</h6>
                                <div className="rating">
                                    <ul className="list-unstyled list-inline">
                                        {data?.duration && <p className='duration2' ><i className="fa-regular fa-clock projects-icon"></i>duration:{data?.duration}</p>}


                                    </ul>
                                </div>

                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
                                    <ProgressBar
                                        // now={50}
                                        now={data.result}
                                        style={{ width: "80%" }}
                                    />

                                    {data?.coursestatus === 'completed' && <label className="desc">Completed</label>}
                                    {data?.coursestatus === 'failed' && <label className="desc">Failed</label>}
                                    {data?.coursestatus === 'started' && <label className="desc">In progress</label>}
                                </div>






                                <p className="desc">{data.description.slice(0, 100)}</p>
                                <div className='d-flex justify-content-between'>
                                <button className="details-btn" onClick={() => detailsFun(data)}>View Details</button>
                                {data?.coursestatus == "completed" && <Button
                                    variant="btn btn-outline-success"
                                    onClick={() => certificateModal(data)}
                                    className="custom-btn "
                                >
                                    Generate Certificate
                                </Button>}
                                </div>



                            </div>

                        </div>

                    </Col>
                }) : loading ? <Skeleton height={220} count={4} className='mb-3' /> : <div style={{ width: "100%", height: "60vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <h2>No Courses Purchased</h2>
                </div>
                }


                {!msg && <Col md="12" className="text-center">
                    <div className='mainpagination'>
                        <ul className='pagination'>
                            <li className='page-item'>
                                <label className='btn btn-outline-success page-link' onClick={prePage}><i className="fa-solid fa-angles-left"></i></label>

                            </li>
                            {numbers?.map((n, i) => (
                                <li className={`page-item ${currentPage === n ? 'active' : ""}`} key={i}>
                                    <label className='btn btn-outline-success page-link' onClick={() => changeCPage(n)}>{n}</label>

                                </li>

                            ))}

                            <li className='page-item'>
                                <label className='btn btn-outline-success page-link' onClick={nextPage}><i className="fa-solid fa-angles-right"></i></label>

                            </li>


                        </ul>
                    </div>
                </Col>}

                {modal &&
                    <Modal show={modal} onHide={cancelmodal}>
                        <div className="custom-modal-content">
                            <Modal.Header className="custom-modal-header" closeButton>
                                <Modal.Title className="custom-modal-title">Course Completed</Modal.Title>
                            </Modal.Header>

                            <Modal.Body className="custom-modal-body">
                                <p>You have successfully completed your courses.</p>
                            </Modal.Body>

                            <div className="custom-modal-footer">
                                {/* <Button
                                    variant="btn btn-outline-dark"
                                    onClick={assesmentModal}
                                    className="custom-btn custom-btn-outline-dark"
                                >
                                    Assessment
                                </Button> */}

                                {/* <Button
                                    variant="btn btn-outline-dark"
                                    onClick={() => setShowCertificate(true)}
                                    className="custom-btn custom-btn-outline-dark"
                                >
                                    Generate Certificate
                                </Button> */}

                                <Button
                                    variant="btn btn-outline-dark"
                                    onClick={viewCourse}
                                    className="custom-btn custom-btn-outline-dark"
                                >
                                    View Course
                                </Button>

                                <Button
                                    onClick={cancelmodal}
                                    className="custom-btn"
                                >
                                    Close
                                </Button>
                            </div>
                        </div>
                    </Modal>

                }




            </Fragment>
            {/* {console.log(QuizTitle, "QuizTitle")} */}
            {show &&
                <Modal show={show} backdrop="static" onHide={handleMainClose} style={{ width: "367px", overflow: "hidden", marginLeft: "30%" }} aria-labelledby="contained-modal-title-vcenter"
                    centered >

                    <Modal.Header closeButton="true" >
                        <h3 style={{ padding: "0px 20px" }}>{QuizTitle}</h3>
                        <hr />
                    </Modal.Header>


                    <iframe src={"https://techbricksedu.com/finalquiz/" + userId + "/" + programid + "/" + tanantid} title="description" style={{ minHeight: "600px", overflow: "hidden" }}  ></iframe>

                    {/* <iframe src={"http://localhost:19006/finalquiz/" + userId + "/" + programid+ "/"+tanantid} title="description" style={{ minHeight: "600px", overflow:"hidden" }} ></iframe>  */}



                </Modal>}
            <Modal show={confirm} onHide={() => setConfirm(false)} backdrop="static" style={{ width: "340px", overflow: "hidden", marginLeft: "30%" }} aria-labelledby="contained-modal-title-vcenter"
                centered>

                <Modal.Header style={{ backgroundColor: "#2C79FF" }}>
                    <h4 className='text-center' style={{ color: "white" }}> Are you sure want to exit from the Test ??</h4>
                </Modal.Header>



                <Modal.Footer style={{ backgroundColor: "#2C79FF" }}>
                    <Button variant="dark" onClick={() => setConfirm(false)} >No</Button>
                    <Button variant="danger" onClick={handleConfirm}>Yes</Button>
                </Modal.Footer>


            </Modal>

            <Modal
                show={showCertificate}
                onHide={() => setShowCertificate(false)}
                size="xl"
                centered
                dialogClassName="certificate-modal"
            >
                <Modal.Header closeButton />

                <Modal.Body className="p-4">
                    <div
                        ref={certificateRef}
                        style={{
                            width: '1050px',
                            height: '652px',
                            margin: 'auto',
                            padding: '20px',
                            backgroundColor: '#fff',
                            border: '2px solid #000',
                            fontFamily: 'Georgia, serif',
                            backgroundImage: `url(${certificateBg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            position: 'relative',
                            textAlign: 'center',
                            border: '1px solid lightgray',
                            borderRadius: '5px',
                        }}
                    >
                        {/* Award Section */}
                        <div
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '60px',
                                width: '90px',
                                height: '300px',
                                background: 'linear-gradient(to bottom, #237df3, #033e8b)',
                                paddingTop: '40px',
                            }}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    left: 0,
                                    bottom: 0,
                                    width: 0,
                                    height: 0,
                                    borderBottom: '30px solid white',
                                    borderLeft: '45px solid transparent',
                                    borderRight: '45px solid transparent',
                                }}
                            />
                            <div style={{ width: '250px', height: '300px', position: 'absolute' }}>
                                <img
                                    src={badge}
                                    alt="Badge"
                                    style={{
                                        width: '180px',
                                        height: 'auto',
                                        position: 'absolute',
                                        top: '-0px',
                                        left: '-40px'
                                    }}
                                />
                            </div>

                            <div style={{ transform: 'translate(8px, 60px)' }}>
                                <h5 style={{ fontSize: '20px', color: 'rgb(255,189,9)', fontWeight: 400 }}>2025</h5>
                                <h5 style={{ fontWeight: 800, color: 'rgb(255,189,9)' }}>AWARD</h5>
                            </div>
                        </div>

                        <div
                            className="end"
                            style={{
                                marginRight: '0px',
                                background: 'rgb(255,254,254)',
                                borderRadius: '40px 5px 5px 40px',
                                boxShadow: '0px 0px 5px rgba(65, 65, 240, 0.38)',
                                padding: '10px',
                                alignItems: 'end',
                                justifySelf: 'end', overflow: 'hidden',
                            }}
                        >
                            <img
                                src={logo}
                                alt="Logo"
                                style={{ background: 'white', width: '180px', height: '30px', objectFit: 'cover', }}
                            />
                        </div>


                        <h1 style={{ fontFamily: 'Times New Roman', fontSize: '60px', letterSpacing: '3px', fontWeight: 'lighter', marginTop: '20px' }}>
                            CERTIFICATE
                        </h1>
                        <p style={{ fontSize: '20px', fontWeight: 600, letterSpacing: '3px', color: '#202020' }}>
                            OF COURSE COMPLETION
                        </p>
                        <p
                            style={{
                                background: 'rgba(1,122,198,0.949)',
                                padding: '5px 25px',
                                borderRadius: '50px',
                                color: '#FFF',
                                fontSize: '16px',
                                fontWeight: 700,
                                margin: '22px auto',
                                width: '43%',
                            }}
                        >
                            PROUDLY PRESENTED TO
                        </p>

                        {/* Name */}
                        <h1
                            style={{
                                fontSize: '70px',
                                fontWeight: 500,
                                fontStyle: 'italic',
                                fontFamily: 'Sofia, sans-serif',
                                textShadow: '2px 2px 3px #ababab',
                                marginTop: '20px',
                            }}
                        >
                            {user?.user?.name}
                        </h1>

                        {/* Course Text */}
                        <p style={{ letterSpacing: '2px', marginTop: '20px', fontSize: '18px' }}>
                            successfully completed{' '}
                            <span style={{ fontWeight: 'bold', color: '#033e8b' }}>{newData?.name}</span>
                        </p>
                        <p
                            style={{
                                fontSize: '14px',
                                fontWeight: 500,
                                padding: '0 10%',
                                marginTop: '5px',
                            }}
                        >
                           During
                            this period, he/she attended the course regularly and keenly participated in the activities including practicals.
                        </p>

                        {/* Footer */}
                        <div
                            style={{
                                marginTop: '50px',
                                display: 'flex',
                                justifyContent: 'space-around',
                                alignItems: 'center',
                            }}
                        >
                            <div>
                                <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#033e8b' }}>{todaysdate}</span>
                                <p
                                    style={{
                                        borderTop: '2px solid #464646',
                                        width: '200px',
                                        marginTop: '5px',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                    }}
                                >
                                    DATE
                                </p>
                            </div>

                            <img
                                src={certified}
                                width="120"
                                style={{ transform: 'translateY(0px)', position: 'absolute' }}
                            />

                            <span
                                style={{
                                    position: 'absolute',
                                    bottom: '30px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#033e8b',
                                    textShadow: '1px 1px 3px white', cursor: 'pointer',
                                }}
                            >
                                www.visualpathedtech.com
                            </span>

                            <div>
                                <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#033e8b' }}>Visualpath</span>
                                <p
                                    style={{
                                        borderTop: '2px solid #464646',
                                        width: '200px',
                                        marginTop: '5px',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                    }}
                                >
                                    AUTHORIZED SIGNATURE
                                </p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <>
                    <Button
                        variant="success"
                        onClick={gencertificate}
                        className="custom-cert-btn animate-pulse"
                    >
                        🎓 Download Certificate
                    </Button>
                </>

            </Modal>






            {/* <FooterTwo/> */}
        </>
    )
}


export default MyProgramsItemList
